import React from 'react';
import Media from 'react-media';
import { getMedia, defaultActionUrlCreator } from '../utilities';
import {
  ResponsiveRow,
  VideoCard,
  TextCard,
  ActionButton,
  IssueItem,
} from '../Elements';

export const TemplateOptions = {
  defaultMarginUnit: '1rem',
  maxIssueCount: 3,
  actionUrlCreator: defaultActionUrlCreator,
};

export const Admin = null;

const getVideoHeight = ({ isPhone, isTablet }) => {
  if (isPhone) {
    return 'auto';
  }
  if (isTablet) {
    return '320px';
  }
  return '480px';
};

const BeastTemplate = ({ page, match: { params } }) => {
  const { text, media, issues, actionBtn } = page;
  const issueCount = Math.min(issues.length, TemplateOptions.maxIssueCount);
  return (
    <Media query="(max-width: 425px)">
      {isPhone => (
        <Media query="(max-width: 768px)">
          {isTablet => (
            <div>
              <VideoCard
                value={getMedia(media)}
                style={{
                  height: getVideoHeight({ isPhone, isTablet }),
                }}
              />
              <TextCard>
                {text}
              </TextCard>

              {issues &&
                <ResponsiveRow blockCount={issueCount} stacked={isTablet}>
                  {issues.slice(0, issueCount).map(issue => (
                    <IssueItem
                      key={issue.icon}
                      blockSize={1}
                      blockStyle={{
                        padding: isTablet
                          ? `${TemplateOptions.defaultMarginUnit} 0`
                          : `${TemplateOptions.defaultMarginUnit}`,

                        ':first-child': { paddingLeft: '0' },
                        ':last-child': { paddingRight: '0' },
                      }}
                      {...issue}
                    />
                  ))}
                </ResponsiveRow>}

              <ResponsiveRow
                stacked={isTablet}
                blockCount={3}
                style={{ justifyContent: 'center' }}
              >
                <ActionButton
                  href={TemplateOptions.actionUrlCreator({
                    ...params,
                    ...page,
                  })}
                  size={1}
                  style={{
                    fontSize: '2.6rem',
                    lineHeight: '2.6rem',
                    padding: '2rem 3rem',
                    height: 'auto',
                    width: '100%',
                  }}
                  blockStyle={{
                    padding: isTablet
                      ? 0
                      : `${TemplateOptions.defaultMarginUnit}`,
                  }}
                  {...actionBtn}
                />
              </ResponsiveRow>
            </div>
          )}

        </Media>
      )}
    </Media>
  );
};

export default BeastTemplate;



// WEBPACK FOOTER //
// ./src/App/join/Templates/Beast/index.js